<div class="grid mb-3">
    <app-platform-health-api-indicators [platform]="platform" [appInsights]="appInsights"></app-platform-health-api-indicators>
</div>

<!-- el bloque ya llegó 'ok': si buildChart() no encontró datos para esta serie concreta, no se deja
     el hueco en silencio (se leería como "todo tranquilo"), se dice qué falta. Si el bloque entero
     fuera 'unavailable' no haría falta: ya lo explica el aviso general de la pestaña. -->
<div *ngIf="platform?.status?.status === 'ok'">
    <app-platform-health-chart title="Tráfico y errores" [chart]="trafficChart" [options]="trafficChartOptions"
        emptyMessage="Tráfico y errores: no hay datos de esta métrica para este periodo."
        helpText="Peticiones por intervalo, con los errores 5xx en el eje de la derecha. Van en un eje propio porque su escala es mucho menor y compartiendo eje serían invisibles."></app-platform-health-chart>
    <app-platform-health-chart title="Tiempo de respuesta" [chart]="latencyChart" [options]="chartOptions"
        emptyMessage="Tiempo de respuesta: no hay datos de esta métrica para este periodo."
        helpText="Tiempo de respuesta medido por la plataforma y, encima, los percentiles de Application Insights cuando están disponibles. Los percentiles solo se superponen si ambas series traen el mismo número de puntos; si no, el eje de tiempo no cuadraría."></app-platform-health-chart>
    <app-platform-health-chart title="App Service" [chart]="appServiceChart" [options]="appServiceChartOptions"
        emptyMessage="App Service: no hay datos de esta métrica para este periodo."
        helpText="CPU y memoria del plan, con el número de instancias en el eje de la derecha. Sirve para ver si un pico de carga coincide con un cambio de escalado."></app-platform-health-chart>

    <!-- en Linux no hay cola observable: esta es la gráfica que hace de cola -->
    <app-platform-health-chart title="Presión de hilos" [chart]="threadsChart" [options]="chartOptions"
        emptyMessage="Presión de hilos: no hay datos de esta métrica para este periodo."
        helpText="Hilos del proceso a lo largo del periodo. Hace las veces de cola: en Linux no hay métrica de cola de peticiones, así que una subida sostenida aquí significa que las peticiones están esperando."></app-platform-health-chart>
</div>

<div *ngIf="appInsights?.status?.status === 'ok'">
    <h3 class="mt-4 mb-2">
        Operaciones que más máquina consumen
        <app-platform-health-help-icon
            text="Ordenada por tiempo total acumulado y no por el p95: lo que agota la máquina no es el endpoint más lento sino el que multiplica duración por volumen. Los conteos vienen corregidos por el muestreo de Application Insights."></app-platform-health-help-icon>
    </h3>
    <p-table [value]="appInsights!.topOperations" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>Operación</th>
                <th class="text-right">Llamadas</th>
                <th class="text-right">p50 (ms)</th>
                <th class="text-right">p95 (ms)</th>
                <th class="text-right">Total (s)</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-op>
            <tr>
                <td>{{ op.name }}</td>
                <td class="text-right">{{ op.count | number:'1.0-0' }}</td>
                <td class="text-right">{{ op.p50 | number:'1.0-0' }}</td>
                <td class="text-right">{{ op.p95 | number:'1.0-0' }}</td>
                <td class="text-right font-bold">{{ op.totalSeconds | number:'1.0-0' }}</td>
            </tr>
        </ng-template>
    </p-table>

    <h3 class="mt-4 mb-2">
        Reparto de dependencias
        <app-platform-health-help-icon
            text="Tiempo total que la aplicación pasa esperando a cada tipo de dependencia. Si SQL domina con diferencia, el cuello está en la base y no en el App Service."></app-platform-health-help-icon>
    </h3>
    <p-table [value]="appInsights!.dependencies" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th>Tipo</th>
                <th class="text-right">Llamadas</th>
                <th class="text-right">Total (s)</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dep>
            <tr>
                <td>{{ dep.type }}</td>
                <td class="text-right">{{ dep.count | number:'1.0-0' }}</td>
                <td class="text-right font-bold">{{ dep.totalSeconds | number:'1.0-0' }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>
